import { render, staticRenderFns } from "./Publications.vue?vue&type=template&id=993e0ab2&scoped=true&"
import script from "./Publications.vue?vue&type=script&lang=ts&"
export * from "./Publications.vue?vue&type=script&lang=ts&"
import style0 from "./Publications.vue?vue&type=style&index=0&id=993e0ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993e0ab2",
  null
  
)

export default component.exports